import { Environment } from './environmentsMock';

/**
 * Counts CertCentral service_provider_accounts per region for a given environment.
 *
 * Logic:
 * - Find the application whose app_code starts with "cc." (CertCentral identifier)
 * - Each entry in service_provider_accounts is a linked CertCentral account
 * - "US" accounts: service_provider_accounts where source_account_friendly_identifier is even index (mock heuristic)
 *   NOTE: In production, the real split (US vs EU per account) should come from a dedicated
 *   field on service_provider_account (e.g. account_region). This mock uses the parent
 *   environment's region to assign all accounts to that region.
 *
 * TODO: Replace this heuristic with real per-account region data from the API.
 * The actual US/EU breakdown shown on tiles (e.g. "2 US, 1 EU CertCentral") requires
 * per-account region info not yet present in the response schema.
 */
export function getCertCentralCounts(env: Environment): { us: number; eu: number } {
  const certCentralApp = env.applications.find((app) =>
    app.app_code.startsWith('cc.')
  );

  if (!certCentralApp || !certCentralApp.service_provider_accounts) {
    return { us: 0, eu: 0 };
  }

  const total = certCentralApp.service_provider_accounts.length;

  // Mock heuristic: assign all accounts to the parent environment's region.
  // When API provides per-account region, replace this block.
  if (env.region === 'US') {
    return { us: total, eu: 0 };
  }
  if (env.region === 'EU') {
    return { us: 0, eu: total };
  }
  // For other regions (IN, NL, etc.) distribute as EU by default until confirmed
  return { us: 0, eu: total };
}